let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("j6VPG")]).then(() => parcelRequire('11pNz'));